module.exports = __webpack_public_path__ + "media/images/login-bonus-kv@2x-f6d9a4d5f13b897c6503711f0df874d7.png";